import React from "react";
import { Check } from "lucide-react";

export function Stepper({ steps, current }) {
  const total = steps.length;
  const percent = ((current) / (total - 1)) * 100;
  return (
    <div data-testid="wizard-stepper" className="w-full">
      <div className="relative flex items-start justify-between gap-2">
        {steps.map((step, index) => {
          const state =
            index < current ? "done" : index === current ? "active" : "todo";
          return (
            <div
              key={step.id}
              className="relative z-10 flex flex-1 flex-col items-center gap-2"
              data-testid={`step-indicator-${step.id}`}
            >
              <div
                className={`flex h-9 w-9 items-center justify-center border-2 font-mono text-xs font-semibold transition-colors ${
                  state === "done"
                    ? "border-[hsl(var(--primary))] bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))]"
                    : state === "active"
                    ? "border-[hsl(var(--primary))] bg-card text-[hsl(var(--primary))]"
                    : "border-border bg-card text-muted-foreground"
                }`}
              >
                {state === "done" ? (
                  <Check className="h-4 w-4" strokeWidth={2.5} />
                ) : (
                  <span>{String(index + 1).padStart(2, "0")}</span>
                )}
              </div>
              <div
                className={`text-center font-mono text-[9px] uppercase tracking-[0.16em] ${
                  state === "todo" ? "text-muted-foreground" : "text-foreground"
                }`}
              >
                {step.title}
              </div>
            </div>
          );
        })}
        {/* Progress line */}
        <div className="absolute left-0 right-0 top-[18px] -z-0 h-[2px] bg-border" />
        <div
          className="absolute left-0 top-[18px] -z-0 h-[2px] bg-[hsl(var(--primary))] transition-[width] duration-500"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
